export enum ArchiveVolumePageType {
  UNLIMITED = 'UNLIMITED',
  LIMITED = 'LIMITED',
}

export const ArchiveVolumePageTypeMap = {
  [ArchiveVolumePageType.UNLIMITED]: '无页数限制',
  [ArchiveVolumePageType.LIMITED]: '页数超限分卷',
};

export const ArchiveVolumePageTypeOptions = [
  {
    label: ArchiveVolumePageTypeMap[ArchiveVolumePageType.UNLIMITED],
    value: ArchiveVolumePageType.UNLIMITED,
  },
  {
    label: ArchiveVolumePageTypeMap[ArchiveVolumePageType.LIMITED],
    value: ArchiveVolumePageType.LIMITED,
  },
];
